import { render } from "./ClienteAdmin.vue?vue&type=template&id=53786320"
import script from "./ClienteAdmin.vue?vue&type=script&lang=ts"
export * from "./ClienteAdmin.vue?vue&type=script&lang=ts"
script.render = render

export default script